// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gl-0";